import * as React from "react";
import { Button } from "../button/button.mjs";
const CollapseToggle = React.forwardRef(function CollapseToggle2(props, ref) {
  const { rotateDegree = 180, rotateDirection = "clockwise", activeText, text, type, isActive, className, ...rest } = props;
  const BEM = () => {
    const classArray = ["collapse-toggle", "collapse-toggle--rotate-degree-".concat(rotateDegree), "collapse-toggle--rotate-direction-".concat(rotateDirection)];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(Button, { ...rest, ref, isActive, className: BEM(), text: isActive && activeText || text, type, iconClass: "collapse-toggle__icon" });
});
export {
  CollapseToggle
};
